/**
 * Global constants used across the application.
 */

/** Maximum character length for comment / feedback text fields. */
export const COMMENT_MAX_LENGTH = 650;

/** Maximum character length for title / description text fields. */
export const TITLE_MAX_LENGTH = 255;
